export const SELECT_ENTITY = "SELECT_ENTITY"
export const DELETE_ENTITY = "DELETE_ENTITY"
export const FETCH_DATA3D_REQUEST = "FETCH_DATA3D_REQUEST"
export const FETCH_DATA3D_SUCCESS = "FETCH_DATA3D_SUCCESS"
export const FETCH_DATA3D_FAILURE = "FETCH_DATA3D_FAILURE"
export const DXF_INITIATE = "DXF_INITIATE"
export const DXF_MODE = "DXF_MODE"
export const WITH_BG_PARTITIONS = "WITH_BG_PARTITIONS"
export const WITH_BG_DOORS = "WITH_BG_DOORS"
export const WITH_BG_BACKGROUND_COLOR = "WITH_BG_BACKGROUND_COLOR"
